import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IntercomEvents, IntercomService } from '../../lib/services';
import {
  JobListingItem,
  LISTING_ITEM_TYPE,
} from '../../jobs-module/models/listing.model';

@Component({
  selector: 'mj-listing-add-item-container',
  templateUrl: './mj-listing-add-item-container.component.html',
  styleUrls: ['./mj-listing-add-item-container.component.scss'],
})
export class MjListingAddItemContainerComponent {
  @Input() public position: number;

  @Output() public onItemAdded = new EventEmitter<JobListingItem>();

  public showAddContainerPromise = null;

  constructor(private _intercomService: IntercomService) {}

  public showAddContainer() {
    this.showAddContainerPromise = true;
  }

  public addItem(item: JobListingItem) {
    this._intercomService.trackEvent(IntercomEvents.LISTING_BLOCK_ADDED);
    clearTimeout(this.showAddContainerPromise);
    this.showAddContainerPromise = null;
    this.onItemAdded.emit(item);
  }

  public addTextAndImageLeftItem() {
    this.addItem({
      type: LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT_IMAGE,
      position: this.position,
      font_rgba: '#000000FF',
      background_rgba: '#FFFFFFFF',
      free_text_image_type: 'text_on_the_right',
    });
  }

  public addImageItem() {
    this.addItem({
      type: LISTING_ITEM_TYPE.LISTING_ITEM_IMAGE,
      position: this.position,
      font_rgba: '#000000FF',
      background_rgba: '#FFFFFF00',
    });
  }

  public addTextItem() {
    this.addItem({
      type: LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT,
      position: this.position,
      font_rgba: '#000000FF',
      background_rgba: '#FFFFFF00',
    });
  }

  public addVideoItem() {
    this._intercomService.trackEvent(IntercomEvents.LISTING_VIDEO_BLOCK_ADDED);
    this.addItem({
      type: LISTING_ITEM_TYPE.LISTING_ITEM_VIDEO,
      position: this.position,
      font_rgba: '#000000FF',
      background_rgba: '#FFFFFF00',
    });
  }

  public addTextAndImageRightItem() {
    this.addItem({
      type: LISTING_ITEM_TYPE.LISTING_ITEM_FREE_TEXT_IMAGE,
      position: this.position,
      font_rgba: '#000000FF',
      free_text_image_type: 'text_on_the_left',
      background_rgba: '#FFFFFF00',
    });
  }

  public onMouseLeave() {
    // if (this.showAddContainerPromise !== false) {
    //     this.showAddContainerPromise = setTimeout(() => {
    //         this.showAddContainerPromise = null;
    //     }, 5000);
    // }
  }

  public onMouseEnter() {
    if (this.showAddContainerPromise !== false) {
      clearTimeout(this.showAddContainerPromise);
      this.showAddContainerPromise = true;
    }
  }

  public onCloseClick() {
    this.showAddContainerPromise = false;
  }
}
